import { appInfo } from '@/mocks/animeData';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16 max-w-[960px] mx-auto">
          <div className="flex-1 w-full text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-2">
              {appInfo.title}
            </h2>
            <p className="text-sm text-foreground-500 mb-4 font-medium">随时随地 追更不停</p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              {appInfo.desc}
            </p>

            <div className="grid grid-cols-2 gap-3 mb-7">
              {appInfo.features.map((feature) => (
                <div
                  key={feature}
                  className="flex items-center gap-2 text-sm text-foreground-700"
                >
                  <div className="w-5 h-5 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-primary-500 text-xs"></i>
                  </div>
                  {feature}
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-foreground-900 text-background-50 font-medium text-sm hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap cursor-pointer">
                <i className="ri-apple-fill text-lg"></i>
                App Store
              </button>
              <button className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer">
                <i className="ri-google-play-fill text-lg"></i>
                Google Play
              </button>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center">
            <div className="relative w-[240px] h-[480px] md:w-[280px] md:h-[560px] rounded-[32px] bg-foreground-900 p-3 overflow-hidden">
              <div className="w-full h-full rounded-[24px] overflow-hidden bg-background-100">
                <img
                  src="https://readdy.ai/api/search-image?query=Mobile%20app%20screen%20mockup%20showing%20anime%20manga%20reader%20interface%20with%20vertical%20scroll%20reading%20mode%2C%20Japanese%20manga%20style%20panels%2C%20warm%20coral%20and%20cream%20color%20palette%2C%20clean%20minimal%20UI%20design%2C%20modern%20mobile%20app%20aesthetic%2C%20soft%20lighting&width=560&height=1120&seq=app-mockup&orientation=portrait"
                  alt="51动漫APP下拉式阅读界面"
                  className="w-full h-full object-cover object-top"
                  onError={(e) => {
                    (e.currentTarget as HTMLImageElement).style.display = 'none';
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}